"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const result_1 = require("./result");
const checkWildcardLimit = (cronFieldType, options) => {
    return (options[cronFieldType].lowerLimit ===
        options.preset[cronFieldType].lowerLimit &&
        options[cronFieldType].upperLimit ===
            options.preset[cronFieldType].upperLimit);
};
const checkSingleElement = (element, cronFieldType, options) => {
    if (element === '*') {
        if (!checkWildcardLimit(cronFieldType, options)) {
            // console.log(
            //   `Field ${cronFieldType} uses wildcard '*', but is limited to ${options[cronFieldType].lowerLimit}-${options[cronFieldType].upperLimit}`
            // )
            return result_1.err(`Field ${cronFieldType} uses wildcard '*', but is limited to ${options[cronFieldType].lowerLimit}-${options[cronFieldType].upperLimit}`);
        }
        return result_1.valid(true);
    }
    if (element === '') {
        return result_1.err(`One of the elements is empty in ${cronFieldType} field.`);
    }
    const number = Number(element);
    if (isNaN(number)) {
        return result_1.err(`Element '${element} of ${cronFieldType} field is invalid.`);
    }
    const { lowerLimit } = options[cronFieldType];
    const { upperLimit } = options[cronFieldType];
    if (lowerLimit && number < lowerLimit) {
        return result_1.err(`Number ${number} of ${cronFieldType} field is smaller than lower limit '${lowerLimit}'`);
    }
    if (upperLimit && number > upperLimit) {
        return result_1.err(`Number ${number} of ${cronFieldType} field is bigger than upper limit '${upperLimit}'`);
    }
    return result_1.valid(true);
};
const checkRangeElement = (element, cronFieldType, options) => {
    if (element === '*') {
        return result_1.err(`'*' can't be part of a range in ${cronFieldType} field.`);
    }
    if (element === '') {
        return result_1.err(`One of the range elements is empty in ${cronFieldType} field.`);
    }
    const number = Number(element);
    if (isNaN(number)) {
        return result_1.err(`Element '${element} of ${cronFieldType} field is invalid.`);
    }
    const { lowerLimit } = options[cronFieldType];
    const { upperLimit } = options[cronFieldType];
    if (lowerLimit && number < lowerLimit) {
        return result_1.err(`Number ${number} of ${cronFieldType} field is smaller than lower limit '${lowerLimit}'`);
    }
    if (upperLimit && number > upperLimit) {
        return result_1.err(`Number ${number} of ${cronFieldType} field is bigger than upper limit '${upperLimit}'`);
    }
    return result_1.valid(true);
};
const checkFirstStepElement = (firstStepElement, cronFieldType, options) => {
    const rangeArray = firstStepElement.split('-');
    if (rangeArray.length > 2) {
        return result_1.err(`List element '${firstStepElement}' is not valid. (More than one '-')`);
    }
    if (rangeArray.length === 1) {
        return checkSingleElement(rangeArray[0], cronFieldType, options);
    }
    if (rangeArray.length === 2) {
        const firstRangeElementResult = checkRangeElement(rangeArray[0], cronFieldType, options);
        const secondRangeElementResult = checkRangeElement(rangeArray[1], cronFieldType, options);
        if (firstRangeElementResult.isError()) {
            return firstRangeElementResult;
        }
        if (secondRangeElementResult.isError()) {
            return secondRangeElementResult;
        }
        if (Number(rangeArray[0]) > Number(rangeArray[1])) {
            return result_1.err(`Lower range end '${rangeArray[0]}' is bigger than upper range end '${rangeArray[1]}' of ${cronFieldType} field.`);
        }
        return result_1.valid(true);
    }
    return result_1.err('Some other error in checkFirstStepElement (rangeArray less than 1)');
};
const checkListElement = (listElement, cronFieldType, options) => {
    // Checks list element for steps like */2, 10-20/2
    const stepArray = listElement.split('/');
    if (stepArray.length > 2) {
        return result_1.err(`List element '${listElement}' is not valid. (More than one '/')`);
    }
    const firstElementResult = checkFirstStepElement(stepArray[0], cronFieldType, options);
    if (firstElementResult.isError()) {
        return firstElementResult;
    }
    if (stepArray.length === 2) {
        const secondStepElement = stepArray[1];
        if (!secondStepElement) {
            return result_1.err(`Second step element '${secondStepElement}' of '${listElement}' is not valid (doesnt exist).`);
        }
        if (isNaN(Number(secondStepElement))) {
            return result_1.err(`Second step element '${secondStepElement}' of '${listElement}' is not valid (not a number).`);
        }
        if (Number(secondStepElement) === 0) {
            return result_1.err(`Second step element '${secondStepElement}' of '${listElement}' is cannot be zero.`);
        }
    }
    return result_1.valid(true);
};
const checkField = (cronField, cronFieldType, options) => {
    if (![
        'seconds',
        'minutes',
        'hours',
        'daysOfMonth',
        'months',
        'daysOfWeek',
        'years',
    ].includes(cronFieldType)) {
        return result_1.err([`Cron field type '${cronFieldType}' does not exist.`]);
    }
    // Check for blank day
    if (cronField === '?') {
        if (cronFieldType === 'daysOfMonth' || cronFieldType === 'daysOfWeek') {
            if (options.useBlankDay) {
                return result_1.valid(true);
            }
            return result_1.err([
                `useBlankDay is not enabled, but is used in ${cronFieldType} field`,
            ]);
        }
        return result_1.err([`blank notation is not allowed in ${cronFieldType} field`]);
    }
    // Check for lists e.g. 4,5,6,8-18,20-40/2
    const listArray = cronField.split(',');
    const checkResults = [];
    listArray.forEach((listElement) => {
        checkResults.push(checkListElement(listElement, cronFieldType, options));
    });
    if (checkResults.every(value => value.isValid())) {
        return result_1.valid(true);
    }
    const errorArray = [];
    checkResults.forEach(result => {
        if (result.isError()) {
            errorArray.push(result.getError());
        }
    });
    return result_1.err(errorArray);
};
exports.default = checkField;
